export default __webpack_public_path__ + "static/media/thozone2.40373f48.gif";